
import React, { useEffect, useState } from "react";

const SecurityWrapper = ({ children }) => {
  const [devToolsOpen, setDevToolsOpen] = useState(false);

  useEffect(() => {
    const threshold = 160;

    const detectDevTools = () => {
      if (
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold
      ) {
        setDevToolsOpen(true);
      }
    };

    detectDevTools();

    window.addEventListener("resize", detectDevTools);

    const interval = setInterval(detectDevTools, 200);

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", detectDevTools);
    };
  }, []);

  useEffect(() => {
    const disableKeys = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && e.key === "I") ||
        (e.ctrlKey && e.shiftKey && e.key === "J") ||
        (e.ctrlKey && e.key === "U")
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", disableKeys);
    document.addEventListener("contextmenu", (e) => e.preventDefault());

    return () => {
      document.removeEventListener("keydown", disableKeys);
    };
  }, []);

  if (devToolsOpen) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          background: "#000",
          color: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "24px",
          fontWeight: "bold",
          zIndex: 99999,
        }}
      >
        Developer Tools Detected. Access Blocked.
      </div>
    );
  }

  return children;
};

export default SecurityWrapper;